<template>
  <div>
    <form method="post" class="search-zipcode-form" autocomplete="off" @submit.prevent="submitBlog()">
      <fieldset class="form-group">
        <label for="title">Title</label>
        <input id="title" class="form-control" type="text" v-model="title" name="title">
      </fieldset>

      <fieldset class="form-group">
        <label for="pageUrl">Page Url</label>
        <input id="pageUrl" class="form-control" type="text" v-model="pageUrl" name="pageUrl">
      </fieldset>

      <fieldset class="form-group">
        <label for="banner-image">Banner Image (Height: 600px & Width: 1440px)</label>
        <input ref="fileInput" id="banner-image" accept="image/png,image/jpeg,image/jpg" type="file" autocomplete="off"
          tabindex="-1" style="display: none;" @change="onChangeFileInput" />
        <CButton class="btn btn-outline-secondary" @click="choosePhoto" :disabled="uploadLoading">
          Choose a profile photo
        </CButton>
        <div>
          <img :src="bannerImgSrc" alt="" v-if="!!bannerImgSrc"
            style="max-width: 100px; max-height: 100px; margin-top: 10px;">
        </div>
      </fieldset>
      <p :if="!!coverImgErrorMsg" class="text-danger">{{ coverImgErrorMsg }}</p>

      <fieldset class="form-group">
        <label for="banner-img-alt">Banner Image Alt</label>
        <input id="banner-img-alt" class="form-control" type="text" v-model="bannerImgAlt" name="bannerImgAlt">
      </fieldset>

      <div class="form-group form-check">
        <input type="checkbox" class="form-check-input" id="active" v-model="active">
        <label class="form-check-label" for="active">Active</label>
      </div>

      <button type="submit" class="btn btn-primary btn-lg submit d-block ml-auto mr-auto"
        :class="{ disabled: isDisabled }" :disabled="isDisabled">Save</button>
    </form>
  </div>
</template>

<script>
import {
  createAuctionBannerMixin,
  auctionBannerStore,
} from "@/mixins/auctionBannerMixin";
import {
  modalStore,
} from "@/mixins/modalsMixin";
import API from "@/api";
import slugify from 'slugify';
import {readAsDataURL} from '@/utils/AsyncFileReader'

export default {
  name: 'VAuctionBannerForm',
  mixins: [createAuctionBannerMixin()],
  data() {
    return {
      title: '',
      pageUrl: '',
      bannerImgSrc: '',
      bannerImgAlt: '',
      active: false,
      isDisabled: false,
      uploadLoading: false,
      coverImgErrorMsg: ''
    };
  },
  props: {
    auctionBanner: {
      type: Object,
      default: null
    }
  },
  watch: {
    auctionBanner() {
      if (this.$props.auctionBanner) {
        this.title = this.$props.auctionBanner.title || ''
        this.pageUrl = this.$props.auctionBanner.pageUrl || ''
        this.bannerImgSrc = this.$props.auctionBanner.bannerImgSrc || ''
        this.bannerImgAlt = this.$props.auctionBanner.bannerImgAlt || ''
        this.active = this.$props.auctionBanner.active || false
      }
    },
    // title() {
    //   this.pageUrl = slugify(this.title, {
    //     replacement: "-", // replace spaces with replacement character, defaults to `-`
    //     remove: undefined, // remove characters that match regex, defaults to `undefined`
    //     lower: false, // convert to lower case, defaults to `false`
    //     strict: true, // strip special characters except replacement, defaults to `false`
    //     locale: "vi", // language code of the locale to use
    //     trim: true, // trim leading and trailing replacement chars, defaults to `true`
    //   });
    // }
  },
  methods: {
    resetData() {
      this.title = ''
      this.pageUrl = ''
      this.bannerImgSrc = ''
      this.bannerImgAlt = ''
      this.active = false
      this.isDisabled = false
      this.uploadLoading = false
      this.coverImgErrorMsg = ''
    },
    async submitBlog() {
      const isUpdateReq = (this.$props.auctionBanner && this.$props.auctionBanner.id);
      try {
        this.isDisabled = true
        const body = {
          title: this.title,
          pageUrl: this.pageUrl,
          bannerImgSrc: this.bannerImgSrc,
          bannerImgAlt: this.bannerImgAlt,
          active: this.active,
        };
        if (isUpdateReq) {
          const auctionBannerId = this.$props.auctionBanner.id;
          await this[auctionBannerStore.actionTypes.ACTION_EDIT_AUCTION_BANNER]({ auctionBannerId, auctionBanner: body });
        } else {
          await this[auctionBannerStore.actionTypes.ACTION_ADD_AUCTION_BANNER](body);
        }
        this.resetData();
        this.closeModal()
      } catch (error) {
        console.log(error)
        console.log(error.response)
      } finally {
        this.isDisabled = false
      }
    },
    closeModal() {
      setTimeout(() => {
        this.$store.dispatch(
          `${modalStore.moduleName}/${modalStore.actionTypes.ACTION_SET_MODAL_CONTENTS}`,
          null
        )
      }, 500)
      this.$modals.close()
    },
    choosePhoto() {
      this.$refs.fileInput && this.$refs.fileInput.click();
    },
    checkImageSize(src) {
      // Initiate the JavaScript Image object.
      const image = new Image();
      // Set the Base64 string return from FileReader as source.
      image.src = src;
      return new Promise((resolve, reject) => {
        //Validate the File Height and Width.
        image.onload = function () {
          const height = this.height;
          const width = this.width;
          // if (height < 600 || width < 1440) {
          //   reject({ imgSize: true, message: 'Image height 600px and width 1440px is allowed' })
          // } else 
          resolve('')
        };
      })
    },
    async onChangeFileInput(event) {
      try {
        this.uploadLoading = true;
        const file = event.target.files[0];
        const imgBase64 = await readAsDataURL(event.target.files[0]);
        await this.checkImageSize(imgBase64);
        this.coverImgErrorMsg = ''
        const formData = new FormData();
        formData.append('upload', file)

        const { data } = await API.auctionBannerManager.uploadBannerImage(formData);
        this.bannerImgSrc = data.url;
        // this.bannerImgSrc = await readAsDataURL(event.target.files[0]);
      } catch (error) {
        console.log(error)
        if (error && error.imgSize) {
          this.coverImgErrorMsg = 'Image height >= 600 px and width >= 1440 px is allowed'
        }
        this.bannerImgSrc = "";
      } finally {
        this.uploadLoading = false;
      }
    },
  }
}
</script>
